import * as React from "react";
import {
  Button,
  makeStyles,
  Spinner,
  tokens,
  useId,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { DataContext } from "../../context/DataContext";
import { useAuth } from "../../authentication/AuthContextProvider";
import { useForm } from "react-hook-form";
import { IAuthRequest, IPasswordrequest } from "../../interfaces/IAuthenticate";
import { FieldInput } from "../common/FieldInput";
import { Header } from "../header/Header";
import { Navigate } from "react-router-dom";
const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  formWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: tokens.spacingVerticalM,
    padding: "40px",
    maxWidth: "400px",
  },
  text: {
    font: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase400,
  },
  subtext: {
    font: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase300,
  },
  button: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralBackground1,
    font: tokens.fontFamilyBase,
  },
  loader: {
    marginTop: tokens.spacingVerticalL,
  },
});
export const PasswordForm = () => {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const auth = useAuth();
  const passwordId = useId("input-password");
  const confirmPasswordId = useId("input-confirm-password");
  const largeId = useId("input-large");
  const styles = useStyles();
  const { isLoading } = dataContext.state;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<IPasswordrequest>();
  const onSubmit = (data: IPasswordrequest) => {
    const request: IAuthRequest = {
      id: auth?.user?.id,
      username: auth?.user?.username,
      password: data.password,
    };

    auth.resetPassword(request, dataContext);
  };

  if (!auth?.user) {
    return <Navigate to="/login" replace />;
  }
  return (
    <div className={styles.root}>
      <Header />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.formWrapper}>
          <div className={styles.form}>
            <text className={styles.text}>{t("labels.createPassword")}</text>
            <text className={styles.subtext}>{t("labels.passwordLength")}</text>
            {isLoading ? (
              <Spinner className={styles.loader} size="large" />
            ) : (
              <div>
                <FieldInput
                  name={"password"}
                  label={t("labels.password")}
                  type={"password"}
                  inputId={passwordId}
                  inputSizeId={largeId}
                  required={true}
                  register={register}
                  errors={errors.password}
                  watch={watch}
                />
                <FieldInput
                  name={"confirmedPassword"}
                  label={t("labels.confirmPassword")}
                  type={"password"}
                  inputId={confirmPasswordId}
                  inputSizeId={largeId}
                  required={true}
                  register={register}
                  errors={errors.confirmedPassword}
                  watch={watch}
                />
              </div>
            )}
          </div>
          <Button
            appearance="primary"
            type="submit"
            className={styles.button}
            size="large"
            disabled={isLoading}
          >
            {t("buttons.create")}
          </Button>
        </div>
      </form>
    </div>
  );
};
